class ProductCard extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE
    this._product = JSON.parse(this.dataset.product);
    this.productImagesSlider = null;

    // COMPONENT ELEMENTS
    this.productVariantsContainer = this.querySelector(
      "#product-variants-container"
    );
    this.variant_template = `
      <svg variant-option
        class="{{#if selected}}active{{/if}}"
        data-images="{{#each_upto product.images 3}}{{ this.src }}{{#unless $last}},{{/unless}}{{/each_upto}}" 
        width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <image x="4" y="4" width="15" height="15" class="" preserveAspectRatio="xMidYMid slice" href="{{ product.images.0.src }}" />
        <path d="M8.47046 2.41113H9.98522V3.9259H8.47046V2.41113Z" fill="#C1C1C1"/>
        <path d="M9.98535 2.41113H11.5001V3.9259H9.98535V2.41113Z" fill="#C1C1C1"/>
        <path d="M5.44092 2.41113H6.95568V3.9259H5.44092V2.41113Z" fill="#C1C1C1"/>
        <path d="M3.92603 3.92627H5.44079V5.44104H3.92603V3.92627Z" fill="#C1C1C1"/>
        <path d="M6.95581 2.41113H8.47058V3.9259H6.95581V2.41113Z" fill="#C1C1C1"/>
        <path d="M16.0442 2.41113H17.559V3.9259H16.0442V2.41113Z" fill="#C1C1C1"/>
        <path d="M17.5591 3.92627H19.0738V5.44104H17.5591V3.92627Z" fill="#C1C1C1"/>
        <path d="M2.41138 5.44092H3.92614V6.95568H2.41138V5.44092Z" fill="#C1C1C1"/>
        <path d="M19.074 5.44092H20.5887V6.95568H19.074V5.44092Z" fill="#C1C1C1"/>
        <path d="M2.41138 6.95557H3.92614V8.47033H2.41138V6.95557Z" fill="#C1C1C1"/>
        <path d="M19.074 6.95557H20.5887V8.47033H19.074V6.95557Z" fill="#C1C1C1"/>
        <path d="M2.41138 8.4707H3.92614V9.98547H2.41138V8.4707Z" fill="#C1C1C1"/>
        <path d="M19.074 8.4707H20.5887V9.98547H19.074V8.4707Z" fill="#C1C1C1"/>
        <path d="M2.41138 9.98535H3.92614V11.5001H2.41138V9.98535Z" fill="#C1C1C1"/>
        <path d="M19.074 9.98535H20.5887V11.5001H19.074V9.98535Z" fill="#C1C1C1"/>
        <path d="M2.41138 11.5H3.92614V13.0148H2.41138V11.5Z" fill="#C1C1C1"/>
        <path d="M19.074 11.5H20.5887V13.0148H19.074V11.5Z" fill="#C1C1C1"/>
        <path d="M2.41138 13.0146H3.92614V14.5294H2.41138V13.0146Z" fill="#C1C1C1"/>
        <path d="M19.074 13.0146H20.5887V14.5294H19.074V13.0146Z" fill="#C1C1C1"/>
        <path d="M2.41138 14.5293H3.92614V16.0441H2.41138V14.5293Z" fill="#C1C1C1"/>
        <path d="M19.074 14.5293H20.5887V16.0441H19.074V14.5293Z" fill="#C1C1C1"/>
        <path d="M2.41138 16.0444H3.92614V17.5592H2.41138V16.0444Z" fill="#C1C1C1"/>
        <path d="M19.074 16.0444H20.5887V17.5592H19.074V16.0444Z" fill="#C1C1C1"/>
        <path d="M13.0146 2.41113H14.5294V3.9259H13.0146V2.41113Z" fill="#C1C1C1"/>
        <path d="M11.5 2.41113H13.0148V3.9259H11.5V2.41113Z" fill="#C1C1C1"/>
        <path d="M14.5295 2.41113H16.0443V3.9259H14.5295V2.41113Z" fill="#C1C1C1"/>
        <path d="M14.5295 20.5889H13.0148V19.0741H14.5295V20.5889Z" fill="#C1C1C1"/>
        <path d="M13.0146 20.5889H11.4999V19.0741H13.0146V20.5889Z" fill="#C1C1C1"/>
        <path d="M17.5591 20.5889H16.0443V19.0741H17.5591V20.5889Z" fill="#C1C1C1"/>
        <path d="M19.0737 19.0737H17.559V17.559H19.0737V19.0737Z" fill="#C1C1C1"/>
        <path d="M16.0444 20.5889H14.5297V19.0741H16.0444V20.5889Z" fill="#C1C1C1"/>
        <path d="M6.95581 20.5889H5.44104V19.0741H6.95581V20.5889Z" fill="#C1C1C1"/>
        <path d="M5.44092 19.0737H3.92615V17.559H5.44092V19.0737Z" fill="#C1C1C1"/>
        <path d="M9.98535 20.5889H8.47059V19.0741H9.98535V20.5889Z" fill="#C1C1C1"/>
        <path d="M11.5 20.5889H9.98523V19.0741H11.5V20.5889Z" fill="#C1C1C1"/>
        <path d="M8.47046 20.5889H6.95569V19.0741H8.47046V20.5889Z" fill="#C1C1C1"/>
      </svg>
    `;
    this.slideTemplate = `
      <div class="w-full h-full">
        <img src="{{ image }}" alt="" class="h-full w-full object-cover object-center">
      </div> 
      `;
    this.variants = this.querySelectorAll("[variant-option]");

    // BINDINGS | EVENT LISTENERS
    this.initializeImagesCarousels();
    const resizeObserver = new ResizeObserver((entries) =>
      this.initializeImagesCarousels()
    );
    resizeObserver.observe(this);
    this.bindEvents();
  }

  bindEvents() {
    this.variants = this.querySelectorAll("[variant-option]");
    this.variants.forEach((variant) => {
      variant.addEventListener("click", this.handleVariantChange.bind(this));
    });

    document.addEventListener("collectionChanged", (event) => {
      this.initializeImagesCarousels();
      this.addEventListener("mouseenter", () => {
        if (this.variants.length) return;
        else this.initializeVariants();
      });
    });
  }

  handleVariantChange(event) {
    this.variants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-option]").classList.add("active");
    let images = event.target
      .closest("[variant-option]")
      .dataset.images.split(",");
    images.forEach((image, index) => {
      let templateSpec = Handlebars.compile(this.slideTemplate);
      let template = templateSpec({ image: image });
      let parser = new DOMParser();
      let doc = parser.parseFromString(template, "text/html");
      this.productImagesSlider.append(doc.body.firstChild);
    });
    let slidesToRemove = this.productImagesSlider.cells.length - images.length;
    this.productImagesSlider.slides.forEach((slide, index) => {
      if (index + 1 > slidesToRemove) return;
      this.productImagesSlider.remove(slide.cells[0].element);
    });
  }

  initializeImagesCarousels() {
    if (this.productImagesSlider) this.productImagesSlider.destroy();
    let productImagesContainer = this.querySelector(
      "#product-images-container"
    );
    if (productImagesContainer.children.length < 2) return;
    this.productImagesSlider = new Flickity(productImagesContainer, {
      // options
      prevNextButtons: false,
      draggable: false,
    });
  }

  initializeVariants() {
    fetch(`/collections/all-products/products.json?limit=10000`)
      .then((response) => response.json())
      .then((data) => {
        this.productVariantsContainer.innerHTML = "";
        let variant_count = 0;
        data.products.forEach((product, index) => {
          // if ((product.title.replace(' ', '').toLowerCase() == this._product.title.replace(' ', '').toLowerCase())) {
          //   if (variant_count > 3) return;
          //   variant_count++;
          //   let selected = product.id != this._product.id ? false : true;
          //   let templateSpec = Handlebars.compile(this.variant_template);
          //   let template = templateSpec({ product: product, selected: selected });
          //   let parser = new DOMParser();
          //   let doc = parser.parseFromString(template, 'text/html');
          //   this.productVariantsContainer.appendChild(doc.body.firstChild);
          // }
          if (index == data.products.length - 1) {
            this.bindEvents();
          }
        });
        // if (variant_count > 3) {
        //   let parser = new DOMParser();
        //   let template = `<span class="text-xs my-auto font-normal text-[#587311] leading-none">+1</span>`;
        //   let doc = parser.parseFromString(template, 'text/html');
        //   this.productVariantsContainer.appendChild(doc.body.firstChild);
        // };
      });
  }
}

customElements.define("product-card", ProductCard);

class CollectionProductCard extends HTMLElement {
  
  constructor() {
    super();
    this.handleQuickBuy = this.handleQuickBuy.bind(this);
    this._product = null;
  }
  
  async connectedCallback() {
    if (this.hasAttribute('data-product')) {
      this._product = JSON.parse(this.getAttribute('data-product'));
      this.init();
      this.bindEvents();
    } else if (this.hasAttribute('data-handle')) {
      this._product = await this.fetchProduct(this.getAttribute('data-handle'));
      this.init();
      this.bindEvents();
    }
  }

  static get observedAttributes() {
    return [
      'data-handle',
    ]
  }

  async attributeChangedCallback(attr, oldValue, newValue) {
    if(attr === 'data-handle') {
      this.connectedCallback();
    }
  }

  init() {
    // COMPONENT STATE
    // this._product =
    //   this.dataset.product != undefined
    //     ? JSON.parse(this.dataset.product)
    //     : null;
    this._selectedVariant = null;
    this._quickBuyActive = false;
    this.colorVariantsInit = false;

    // COMPONENT ELEMENTS
    this.quickBuyContainer = this.querySelector(".product-quick-buy-container");
    this.quickBuyButton = this.querySelector("#quick-buy-button");
    this.quickBuyAdd = this.querySelector("#quick-buy-add");
    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.mobileCoverImage = this.querySelector("[mobile-cover-image]");
    this.sizeVariantSkeleton = `<div class="w-12 h-7 animate-pulse bg-slate-700 rounded-sm"></div>`;
    this.sizeVariantTemplate = `<button variant-size-option class="size-variant uppercase w-20 h-max py-1 text-white border border-gray-500 font-light text-sm">{{ size_option }}</button>`;
    this.ColorVariantSkeleton = `<div class="product-color-variant-skeleton cursor-pointer h-6 w-6 rounded-full animate-pulse bg-slate-700"></div>`;
    this.colorVariantTemplate = `
      <button 
        variant-color-option 
        style="background-color: {{ product.options.[1].values.[0] }}"
        data-handle="{{ product.handle }}" class="relative group product-color-variant cursor-pointer h-6 w-6 rounded-full overflow-hidden"
        >
          <div class="z-50 text-xs text-white uppercase bg-black rounded-sm px-2 py-1 whitespace-nowrap absolute -top-7 left-1/2 -translate-x-1/2 hidden group-hover:block">
            {{ product.options.[1].values.[0] }}
          </div>
          <img data-lazy src="{{ product.images.[0].src }}" alt="{{ product.title }}" class="h-full w-full object-cover scale-[5] object-center">
      </button>
    `;
    this.colorVariantsContainer = this.querySelector(
      "#color-variants-container"
    );
    this.imagesSliderContainer = this.querySelector(
      ".collection-product-images-slider"
    );
    this.imagesSliderTrack = this.querySelector(".blaze-track");
    this.imagesSlider = null;

    // Add resize observer
    this.resizeObserver = new ResizeObserver(entries => {
      this.handleResize();
    });
    this.resizeObserver.observe(this);
  }

  handleResize() {
    // Reinitialize image carousel
    if (this.imagesSlider) {
      this.imagesSlider.destroy();
    }
    this.initializeImagesCarousel();
    
    // Handle mobile cover image visibility
    if (window.innerWidth > 768 && this.mobileCoverImage) {
      this.imagesSlider?.remove(this.mobileCoverImage);
    } else if (window.innerWidth <= 768 && this.mobileCoverImage) {
      // Re-add mobile cover image if needed
      this.imagesSlider?.insert(this.mobileCoverImage, 0);
    }
  }

  async bindEvents() {
    // this._product != null
    //   ? ""
    //   : (this._product = await this.fetchProduct(this.dataset.handle));
    this.quickBuyAdd.addEventListener("click", this.handleAddToCart.bind(this));
    this.quickBuyButton?.addEventListener(
      "click",
      this.handleQuickBuy
    );
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    document.body.addEventListener("click", (e) => {
      if (
        e.target.closest("#quick-buy-button") == this.quickBuyButton &&
        !this.quickBuyContainer.classList.contains("invisible")
      )
        return;
      if (e.target.closest(".product-quick-buy-container")) return;
      if (!this.colorVariantsInit) return;
      if (this._quickBuyActive) {
        this.handleQuickBuy(e)
      }
    });
    this.colorVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    this.sizeVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();
    let isHovering = false;
    this.addEventListener("mouseenter", () => {
      isHovering = true;
      setTimeout(() => {
        if (isHovering) {
          this.imagesSlider?.next(false, false);
        }
      }, 200);
    });
    this.addEventListener("mouseleave", () => {
      isHovering = false;
      if (this.imagesSlider) {
        this.imagesSlider.select(0, false);
      }
    });
    this.initializeImagesCarousel();

    this.touchstartX = { x: 0, time: 0 };
    this.touchendX = { x: 0, time: 0 };

    this.addEventListener(
      "touchstart",
      (event) => {
        this.touchstartX = {
          x: event.changedTouches[0].screenX,
          time: new Date(),
        };
        console.log("touchstart", this.touchstartX);
      },
      false
    );

    this.addEventListener(
      "touchend",
      (event) => {
        this.touchendX = {
          x: event.changedTouches[0].screenX,
          time: new Date(),
        };
        console.log("touchend", this.touchendX);
        this.handleSwipe();
      },
      false
    );
  }

  reBindEvents() {
    console.log("rebind");
    this._selectedVariant = null;
    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    this.sizeVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    this.colorVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();
  }

  initializeImagesCarousel() {
    if (!this.imagesSliderContainer || this.imagesSliderContainer.children.length < 2) return;

    this.imagesSlider = new Flickity(this.imagesSliderContainer, {
      fade: true,
      wrapAround: true,
      prevNextButtons: this.dataset.hideArrows == "true" ? false : true
    });

    window.dispatchEvent(new CustomEvent('product-images-initialized'));

    if (window.innerWidth > 768 && this.mobileCoverImage) {
      this.imagesSlider.remove(this.mobileCoverImage);
    }

    this.imagesSliderContainer.classList.remove("invisible");
    this.imagesSliderContainer.classList.add("!visible");
  }

  handleSwipe() {
    console.log(this.touchstartX, this.touchendX);
    if (this.touchendX != this.touchstartX) {
      let swipeDistance = Math.abs(this.touchendX.x - this.touchstartX.x);
      if (swipeDistance < 1) {
        let link = this.imagesSliderContainer.querySelector("a");
        if (link) {
          setTimeout(() => {
            link.click();
          }, 100); // delay of 100ms
        }
      } else if (swipeDistance < 15) {
        this.imagesSlider?.next(false, false);
      }
    }
  }

  handleQuickBuy(event) {
    event.preventDefault();
    this._quickBuyActive = !this._quickBuyActive;
    this.quickBuyContainer.classList.toggle("invisible");
    if (!this.colorVariantsInit) {
      this.initColorVariants();
    }
    if (!this._quickBuyActive) {
      this.defaultColorVariant.click();
    }
  }

  initColorVariants() {
    [1, 2, 3].forEach((variant) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.ColorVariantSkeleton, "text/html");
      this.colorVariantsContainer.appendChild(doc.body.firstChild);
    });
    fetch(`/collections/all-products/products.json?title=simple&limit=10000`)
      .then((response) => response.json())
      .then((data) => {
        let colorVariants = document.querySelectorAll(
          ".product-color-variant-skeleton"
        );
        colorVariants.forEach((variant) => {
          variant.remove();
        });
        data.products.forEach((product, index) => {
          if (
            product.title.replace(" ", "").toLowerCase() ==
              this._product.title.replace(" ", "").toLowerCase() &&
            product.id != this._product.id
          ) {
            let templateSpec = Handlebars.compile(this.colorVariantTemplate);
            let template = templateSpec({ product: product });
            let parser = new DOMParser();
            let doc = parser.parseFromString(template, "text/html");
            this.colorVariantsContainer.appendChild(doc.body.firstChild);
          }
        });
        this.colorVariantsInit = true;
        this.reBindEvents();
      });
  }

  handleAddToCart(event) {
    event.preventDefault();
    if (!this._selectedVariant?.available) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: this._selectedVariant.id,
            quantity: 1,
            properties: { Gift: false },
          },
        ],
      }),
    }).then(() => {
      document.dispatchEvent(new CustomEvent("cartUpdated"));
    });
  }

  handleQuickBuyVariantChange(event) {
    if (
      event.target
        .closest("[variant-color-option]")
        .classList.contains("active")
    )
      return;
    this.colorVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-color-option]").classList.add("active");
    this.sizeVariants.forEach((variant) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.sizeVariantSkeleton, "text/html");
      variant.replaceWith(doc.body.firstChild);
    });
    let productHandle = event.target.closest("[variant-color-option]").dataset
      .handle;
    fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
      .then((response) => response.json())
      .then((data) => {
        this._product = data;
        let sizeOptions = data.variants.map((variant) => {
          return variant.option1;
        });
        let featuredImage = data.featured_image;
        let sizeVariantContainer = this.querySelector(
          "#size-variants-container"
        );
        let variantImageTag = this.querySelector("[featured-image]");
        variantImageTag == null ? "" : (variantImageTag.src = featuredImage);
        sizeVariantContainer.innerHTML = "";
        sizeOptions.forEach((sizeOption, index) => {
          let templateSpec = Handlebars.compile(this.sizeVariantTemplate);
          let template = templateSpec({ size_option: sizeOption });
          let parser = new DOMParser();
          let doc = parser.parseFromString(template, "text/html");
          sizeVariantContainer.appendChild(doc.body.firstChild);
        });
        this.reBindEvents();
        data.available
          ? (this.quickBuyAdd.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("!flex"))
          : (this.quickBuyAdd.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("!flex"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute(
              "id",
              `klaviyo-data-handle-${this._product.handle}`
            ),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
            this.querySelector(".klaviyo-product-container-quick-add")
              ?.querySelector(".klaviyo-bis-trigger")?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
      });
  }

  handleQuickBuySizeChange(event) {
    this.sizeVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-size-option]").classList.add("active");
    console.log(event.target.closest("[variant-size-option]").innerHTML.trim());
    this.selectedVariant = this._product.variants.find((variant) => {
      return (
        variant.option1 ==
        event.target.closest("[variant-size-option]").innerHTML.trim()
      );
    });
    this._selectedVariant = this.selectedVariant;
    this.selectedVariant.available
      ? (this.quickBuyAdd.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("!flex"))
      : (this.quickBuyAdd.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("!flex"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute("id", `klaviyo-data-handle-${this._product.handle}`),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
        this.querySelector(".klaviyo-product-container-quick-add")
          ?.querySelector(".klaviyo-bis-trigger")
          ?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
  }

  fetchProduct(handle) {
    return new Promise((resolve, reject) => {
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        });
    });
  }

  disconnectedCallback() {
    // Clean up resize observer when element is removed
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.imagesSlider) {
      this.imagesSlider.destroy();
    }
  }
}

customElements.define("collection-product-card", CollectionProductCard);

class collectionTypeFilter extends HTMLElement {
  constructor() {
    super();

    this.scrollRightButton = this.querySelector("[scroll-right-button]");
    this.scrollLeftButton = this.querySelector("[scroll-left-button]");
    this.scrollContainer = this.querySelector("[scroll-container]");
    this.scrollContainerLeft = this.querySelector("[scroll-container-left]");
    this.scrollContainerRight = this.querySelector("[scroll-container-right]");
    this.bindEvents();
  }

  bindEvents() {
    this.scrollRightButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.scrollContainer.scrollBy({ left: 200, behavior: "smooth" });
      this.scrollContainerLeft.classList.remove("hidden");
      setTimeout(() => {
        if (
          Math.round(
            this.scrollContainer.scrollLeft +
              this.scrollContainer.clientWidth +
              50
          ) >= Math.round(this.scrollContainer.scrollWidth)
        ) {
          this.scrollContainerRight.classList.add("hidden");
        }
      }, 200);
    });
    this.scrollLeftButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.scrollContainer.scrollBy({ left: -200, behavior: "smooth" });
      this.scrollContainerRight.classList.remove("hidden");
      setTimeout(() => {
        if (this.scrollContainer.scrollLeft - 50 <= 0) {
          this.scrollContainerLeft.classList.add("hidden");
        }
      }, 200);
    });
  }
}

customElements.define("collection-type-filter", collectionTypeFilter);

class CollectionSliderProductCard extends CollectionProductCard {
  constructor() {
    super();
  }

  bindEvents() {
    this.quickBuyAdd.addEventListener("click", this.handleAddToCart.bind(this));
    this.addEventListener("mouseenter", this.handleQuickBuy);
    this.addEventListener("mouseleave", () => {
      this._quickBuyActive = !this._quickBuyActive;
      this.quickBuyContainer.classList.toggle("invisible");
    });
    document.body.addEventListener("click", (e) => {
      if (
        e.target.closest("#quick-buy-button") == this.quickBuyButton &&
        !this.quickBuyContainer.classList.contains("invisible")
      )
        return;
      if (e.target.closest(".product-quick-buy-container")) return;
      if (!this.colorVariantsInit) return;
      if (this._quickBuyActive) {
        this.handleQuickBuy
      }
    });
    this.colorVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    this.sizeVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();
  }
}

customElements.define(
  "collection-slider-product-card",
  CollectionSliderProductCard
);

class CartProductCard extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE
    this._product =
      this.dataset.product != undefined
        ? JSON.parse(this.dataset.product)
        : null;
    this._selectedVariant = null;
    this._quickBuyActive = false;
    this.colorVariantsInit = false;

    // COMPONENT ELEMENTS
    this.quickBuyContainer = this.querySelector(".product-quick-buy-container");
    this.quickBuyButton = this.querySelector("#quick-buy-button");
    this.quickBuyAdd = this.querySelector("#quick-buy-add");
    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.sizeVariantSkeleton = `<div class="w-12 h-7 animate-pulse bg-slate-700 rounded-sm"></div>`;
    this.sizeVariantTemplate = `<button type="button" variant-size-option class="size-variant uppercase w-12 h-7 text-black border border-gray-500 font-light text-sm">{{ size_option }}</button>`;
    this.ColorVariantSkeleton = `<div class="product-color-variant-skeleton cursor-pointer h-5 w-5 rounded-full animate-pulse bg-slate-700"></div>`;
    this.colorVariantTemplate = `
      <button 
        type="button"
        variant-color-option 
        style="background-color: {{ product.options.[1].values.[0] }}"
        data-handle="{{ product.handle }}" class="relative group product-color-variant cursor-pointer h-5 w-5 rounded-full overflow-hidden"
      >
          <div class="z-50 text-xs text-white uppercase bg-black rounded-sm px-2 py-1 whitespace-nowrap absolute -top-7 left-1/2 -translate-x-1/2 hidden group-hover:block">
            {{ product.options.[1].values.[0] }}
          </div>
          <img data-lazy src="{{ product.images.[0].src }}" alt="{{ product.title }}" class="h-full w-full object-cover scale-[5] object-center">
      </button>
    `;
    this.colorVariantsContainer = this.querySelector(
      "#color-variants-container"
    );
    this.colorDropdownOptions = this.querySelector("[color-dropdown-options]");
    this.colorDropdownTrigger = this.querySelector("[color-dropdown-trigger]");
    this.colorDropdownSelected = this.querySelector(
      "[color-dropdown-selected]"
    );

    this.sizeVariantsContainer = this.querySelector("#size-variants-container");
    this.sizeDropdownOptions = this.querySelector("[size-dropdown-options]");
    this.sizeDropdownTrigger = this.querySelector("[size-dropdown-trigger]");
    this.selectedSizeLabel = this.querySelector("[selected-size]");

    this.productQuickBuyTrigger = this.querySelector(
      "[product-quick-buy-trigger]"
    );

    // BINDINGS | EVENT LISTENERS
    this.bindEvents();
  }

  async bindEvents() {
    this._product != null
      ? ""
      : (this._product = await this.fetchProduct(this.dataset.handle));
    this.quickBuyAdd.addEventListener("click", this.handleAddToCart.bind(this));
    // this.addEventListener('mouseenter', this.handleQuickBuy.bind(this));
    this.productQuickBuyTrigger?.addEventListener(
      "click",
      this.handleQuickBuy
    );
    // this.addEventListener('mouseleave', () => {
    //   this._quickBuyActive = !this._quickBuyActive;
    //   // this.quickBuyContainer.classList.toggle('invisible');
    // });
    this.quickBuyButton?.addEventListener(
      "click",
      this.handleQuickBuy
    );
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    document.body.addEventListener("click", (e) => {
      if (
        e.target.closest("#quick-buy-button") == this.quickBuyButton &&
        !this.quickBuyContainer.classList.contains("invisible")
      )
        return;
      if (e.target.closest(".product-quick-buy-container")) return;
      if (!this.colorVariantsInit) return;
      if (this._quickBuyActive) {
        this.handleQuickBuy
      }
    });
    this.colorVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    this.sizeVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();

    this.colorDropdownTrigger?.addEventListener(
      "click",
      this.handleColorDropdown.bind(this)
    );
    this.sizeDropdownTrigger?.addEventListener(
      "click",
      this.handleSizeDropdown.bind(this)
    );
  }

  reBindEvents() {
    this._selectedVariant = null;
    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    this.sizeVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    this.colorVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();
  }

  handleQuickBuy(event) {
    console.log("handleQuickBuy",this);
    event.preventDefault();
    this._quickBuyActive = !this._quickBuyActive;
    this.quickBuyContainer.classList.toggle("hidden");
    if (!this.colorVariantsInit) {
      this.initColorVariants();
    }
    if (!this._quickBuyActive) {
      this.defaultColorVariant.click();
    }
    // if (!this._quickBuyActive) {
    //   this.handleColorDropdown();
    //   this.handleSizeDropdown();
    // }
  }

  initColorVariants() {
    [1, 2, 3].forEach((variant) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.ColorVariantSkeleton, "text/html");
      this.colorVariantsContainer.appendChild(doc.body.firstChild);
    });
    fetch(`/collections/all-products/products.json?title=simple&limit=10000`)
      .then((response) => response.json())
      .then((data) => {
        let colorVariants = document.querySelectorAll(
          ".product-color-variant-skeleton"
        );
        colorVariants.forEach((variant) => {
          variant.remove();
        });
        data.products.forEach((product, index) => {
          if (
            product.title.replace(" ", "").toLowerCase() ==
              this._product.title.replace(" ", "").toLowerCase() &&
            product.id != this._product.id
          ) {
            let templateSpec = Handlebars.compile(this.colorVariantTemplate);
            let template = templateSpec({ product: product });
            let parser = new DOMParser();
            let doc = parser.parseFromString(template, "text/html");
            this.colorVariantsContainer.appendChild(doc.body.firstChild);
          }
        });
        this.colorVariantsInit = true;
        this.reBindEvents();
      });
  }

  handleAddToCart(event) {
    event.preventDefault();
    if (!this._selectedVariant?.available) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: this._selectedVariant.id,
            quantity: 1,
            properties: { Gift: false },
          },
        ],
      }),
    }).then(() => {
      document.dispatchEvent(new CustomEvent("cartUpdated"));
    });
  }

  handleQuickBuyVariantChange(event) {
    if (
      event.target
        .closest("[variant-color-option]")
        .classList.contains("active")
    )
      return;
    this.colorVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-color-option]").classList.add("active");
    this.sizeVariants.forEach((variant) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.sizeVariantSkeleton, "text/html");
      // variant.replaceWith(doc.body.firstChild);
    });
    let productHandle = event.target.closest("[variant-color-option]").dataset
      .handle;
    fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
      .then((response) => response.json())
      .then((data) => {
        this._product = data;
        let sizeOptions = data.variants.map((variant) => {
          return variant.option1;
        });
        let featuredImage = data.featured_image;
        this.colorDropdownSelected.src = featuredImage;
        let sizeVariantContainer = this.querySelector(
          "#size-variants-container"
        );
        let variantImageTag = this.querySelector("[featured-image]");
        variantImageTag == null ? "" : (variantImageTag.src = featuredImage);
        sizeVariantContainer.innerHTML = "";
        sizeOptions.forEach((sizeOption, index) => {
          let templateSpec = Handlebars.compile(this.sizeVariantTemplate);
          let template = templateSpec({ size_option: sizeOption });
          let parser = new DOMParser();
          let doc = parser.parseFromString(template, "text/html");
          sizeVariantContainer.appendChild(doc.body.firstChild);
        });
        this.reBindEvents();
        data.available
          ? (this.quickBuyAdd.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("!flex"))
          : (this.quickBuyAdd.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("!flex"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute(
              "id",
              `klaviyo-data-handle-${this._product.handle}`
            ),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
            this.querySelector(".klaviyo-product-container-quick-add")
              ?.querySelector(".klaviyo-bis-trigger")
              ?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
      });
  }

  // todo: refactor this
  handleQuickBuySizeChange(event) {
    this.sizeVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-size-option]").classList.add("active");
    this.selectedVariant = this._product.variants.find((variant) => {
      return (
        variant.option1 ==
        event.target.closest("[variant-size-option]").innerHTML.trim()
      );
    });
    this._selectedVariant = this.selectedVariant;
    this.sizeDropdownOptions.classList.add("hidden");

    this.selectedVariant.option1;
    this.selectedSizeLabel.innerHTML = this.selectedVariant.option1;
    this.selectedVariant.available
      ? (this.quickBuyAdd.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("!flex"))
      : (this.quickBuyAdd.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("!flex"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute("id", `klaviyo-data-handle-${this._product.handle}`),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
        this.querySelector(".klaviyo-product-container-quick-add")
          ?.querySelector(".klaviyo-bis-trigger")
          ?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
  }

  handleColorDropdown(event) {
    event.preventDefault();
    this.colorDropdownOptions.classList.toggle("hidden");
  }

  handleSizeDropdown(event) {
    event.preventDefault();
    if (event.target.closest("[size-dropdown-options]")) return;
    this.sizeDropdownOptions.classList.toggle("hidden");
  }

  fetchProduct(handle) {
    return new Promise((resolve, reject) => {
      fetch(`${handle}.js`)
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        });
    });
  }
}

customElements.define("cart-product-card", CartProductCard);

class MiniQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.priceContainer = this.querySelector("[price-container]");
    this.quickBuyContainer = this.querySelector("[quick-buy-container]");

    this.sizeVariantSkeleton = `<div class="w-12 h-7 animate-pulse bg-slate-700 rounded-sm"></div>`;
    this.sizeVariantTemplate = `<button type="button" variant-size-option class="size-variant uppercase w-12 h-7 text-black border border-gray-500 font-light text-sm">{{ size_option }}</button>`;
    this.ColorVariantSkeleton = `<div class="product-color-variant-skeleton cursor-pointer h-5 w-5 rounded-full animate-pulse bg-slate-700"></div>`;
    this.colorVariantTemplate = `
      <button 
        type="button"
        variant-color-option 
        style="background-color: {{ product.options.[1].values.[0] }}"
        data-handle="{{ product.handle }}" class="relative group product-color-variant cursor-pointer h-5 w-5 rounded-full overflow-hidden"
      >
          <div class="z-50 text-xs text-white uppercase bg-black rounded-sm px-2 py-1 whitespace-nowrap absolute -top-7 left-1/2 -translate-x-1/2 hidden group-hover:block">
            {{ product.options.[1].values.[0] }}
          </div>
          <img data-lazy src="{{ product.images.[0].src }}" alt="{{ product.title }}" class="h-full w-full object-cover scale-[5] object-center">
      </button>
    `;

    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.sizeVariantsContainer = this.querySelector("#size-variants-container");
    this.sizeDropdownTrigger = this.querySelector("[size-dropdown-trigger]");
    this.sizeDropdownOptions = this.querySelector("[size-dropdown-options]");
    this.selectedSizeLabel = this.querySelector("[selected-size]");

    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.colorVariantsContainer = this.querySelector(
      "#color-variants-container"
    );
    this.colorDropdownOptions = this.querySelector("[color-dropdown-options]");
    this.colorDropdownTrigger = this.querySelector("[color-dropdown-trigger]");
    this.colorDropdownSelected = this.querySelector(
      "[color-dropdown-selected]"
    );
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );

    // Fetch or receive product data
    this._product =
      this.dataset.product != undefined
        ? JSON.parse(this.dataset.product)
        : null;
    this._selectedVariant = null;
    this._quickBuyActive = false;
    this.colorVariantsInit = false;

    this.quickBuyAdd = this.querySelector("#quick-buy-add");

    this.bindEvents();
  }

  async bindEvents() {
    this.addEventListener("mouseenter", this.toggleQuickBuy.bind(this));
    this.addEventListener("mouseleave", this.toggleQuickBuy.bind(this));

    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );

    this.sizeDropdownTrigger?.addEventListener(
      "click",
      this.handleSizeDropdown.bind(this)
    );
    this.colorDropdownTrigger?.addEventListener(
      "click",
      this.handleColorDropdown.bind(this)
    );

    // Add event listeners for variant selection
    this.colorVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });
    this.sizeVariants.forEach((variant) => {
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    this.quickBuyAdd.addEventListener("click", this.handleAddToCart.bind(this));

    this.initColorVariants();

    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    console.log(firstAvailiableVariant);
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    console.log(defaultVariant);
    defaultVariant?.click();
  }

  async reBindEvents() {
    // this.sizeDropdownTrigger?.addEventListener('click', this.handleSizeDropdown.bind(this));
    // this.colorDropdownTrigger?.addEventListener('click', this.handleColorDropdown.bind(this));
    this._selectedVariant = null;
    this.sizeVariants = this.querySelectorAll("[variant-size-option]");
    this.colorVariants = this.querySelectorAll("[variant-color-option]");
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );
    this.defaultColorVariant = this.querySelector(
      "[default-variant-color-option]"
    );

    // Add event listeners for variant selection
    this.sizeVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuySizeChange.bind(this)
      );
    });
    this.colorVariants.forEach((variant) => {
      variant.removeEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
      variant.addEventListener(
        "click",
        this.handleQuickBuyVariantChange.bind(this)
      );
    });

    if (!this.colorVariantsInit) {
      this.initColorVariants();
    }

    let firstAvailiableVariant = this._product.variants.find((variant) => {
      return variant.available == true;
    });
    let defaultVariant = null;
    firstAvailiableVariant == undefined
      ? ""
      : (defaultVariant = Array.from(this.sizeVariants).find((variant) => {
          return variant.innerHTML == firstAvailiableVariant.option1 || null;
        }));
    defaultVariant?.click();
  }

  toggleQuickBuy(event) {
    this.classList.toggle("to-transparent");
    this.classList.toggle("to-[#00000080]");
    this.quickBuyContainer.classList.toggle("!hidden");
    this.priceContainer.classList.toggle("hidden");
  }

  initColorVariants() {
    console.log("initColorVariants");
    // [1,2,3].forEach((variant) => {
    //   let parser = new DOMParser();
    //   let doc = parser.parseFromString(this.ColorVariantSkeleton, 'text/html');
    //   this.colorVariantsContainer.appendChild(doc.body.firstChild);
    // });
    fetch(
      `/collections/all-products/products.json?title=${this._product.title}&limit=10000`
    )
      .then((response) => response.json())
      .then((data) => {
        // let colorVariants = document.querySelectorAll('.product-color-variant-skeleton');
        // colorVariants.forEach((variant) => {
        //   variant.remove();
        // });
        console.log(data);
        data.products.forEach((product, index) => {
          if (
            product.title.replace(" ", "").toLowerCase() ==
              this._product.title.replace(" ", "").toLowerCase() &&
            product.id != this._product.id
          ) {
            let templateSpec = Handlebars.compile(this.colorVariantTemplate);
            let template = templateSpec({ product: product });
            let parser = new DOMParser();
            let doc = parser.parseFromString(template, "text/html");
            this.colorVariantsContainer.appendChild(doc.body.firstChild);
          }
        });
        this.colorVariantsInit = true;
        this.reBindEvents();
      });
  }

  handleSizeDropdown(event) {
    event.preventDefault();
    console.log("open dropdown");
    if (event.target.closest("[size-dropdown-options]")) return;
    this.sizeDropdownOptions.classList.toggle("hidden");
  }

  handleColorDropdown(event) {
    event.preventDefault();
    this.colorDropdownOptions.classList.toggle("hidden");
  }

  handleQuickBuySizeChange(event) {
    this.sizeVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-size-option]").classList.add("active");
    this.selectedVariant = this._product.variants.find((variant) => {
      return (
        variant.option1 ==
        event.target.closest("[variant-size-option]").innerHTML.trim()
      );
    });

    this._selectedVariant = this.selectedVariant;
    this.selectedVariant.available
      ? (this.quickBuyAdd.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("!flex"))
      : (this.quickBuyAdd.classList.add("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.remove("hidden"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.classList.add("!flex"),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute(
          "id",
          `klaviyo-data-handle-${this._product.handle}`
        ),
        this.querySelector(
          ".klaviyo-product-container-quick-add"
        )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
        this.querySelector(".klaviyo-product-container-quick-add")
          ?.querySelector(".klaviyo-bis-trigger")
          ?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
    this.selectedSizeLabel.innerHTML = this.selectedVariant.option1;
    this.sizeDropdownOptions.classList.add("hidden");
  }

  handleQuickBuyVariantChange(event) {
    if (
      event.target
        .closest("[variant-color-option]")
        .classList.contains("active")
    )
      return;
    this.colorVariants.forEach((variant) => variant.classList.remove("active"));
    event.target.closest("[variant-color-option]").classList.add("active");
    this.sizeVariants.forEach((variant) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(this.sizeVariantSkeleton, "text/html");
      variant.replaceWith(doc.body.firstChild);
    });
    let productHandle = event.target.closest("[variant-color-option]").dataset
      .handle;
    fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
      .then((response) => response.json())
      .then((data) => {
        this._product = data;
        let sizeOptions = data.variants.map((variant) => {
          return variant.option1;
        });
        let featuredImage = data.featured_image;
        this.colorDropdownSelected.src = featuredImage;
        let sizeVariantContainer = this.querySelector(
          "#size-variants-container"
        );
        let variantImageTag = this.querySelector("[featured-image]");
        variantImageTag == null ? "" : (variantImageTag.src = featuredImage);
        sizeVariantContainer.innerHTML = "";
        sizeOptions.forEach((sizeOption, index) => {
          let templateSpec = Handlebars.compile(this.sizeVariantTemplate);
          let template = templateSpec({ size_option: sizeOption });
          let parser = new DOMParser();
          let doc = parser.parseFromString(template, "text/html");
          sizeVariantContainer.appendChild(doc.body.firstChild);
        });
        this.reBindEvents();
        data.available
          ? (this.quickBuyAdd.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("!flex"))
          : (this.quickBuyAdd.classList.add("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.remove("hidden"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.classList.add("!flex"),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute(
              "id",
              `klaviyo-data-handle-${this._product.handle}`
            ),
            this.querySelector(
              ".klaviyo-product-container-quick-add"
            )?.setAttribute("data-klaviyo-handle", `${this._product.handle}`),
            this.querySelector(".klaviyo-product-container-quick-add")
              ?.querySelector(".klaviyo-bis-trigger")
              ?.setAttribute("data-klaviyo-handle", `${this._product.handle}`));
      }); 
  }

  handleAddToCart(event) {
    event.preventDefault();
    if (!this._selectedVariant?.available) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: this._selectedVariant.id,
            quantity: 1,
            properties: { Gift: false },
          },
        ],
      }),
    }).then(() => {
      document.dispatchEvent(new CustomEvent("cartUpdated"));
    });
  }
}

customElements.define("mini-quick-add", MiniQuickAdd);
